<template>
	<div>
		<template v-if="formCreateInject">
			<el-input @click.native="penetrate?customerpreview:''" :placeholder="placeholder" :class="{penetrate:penetrate && (readonly || disabled)}" :value="value" :size="size" :readonly="readonly" :disabled="disabled" @input="change">
				<el-button type="info" :icon="loading?'el-icon-loading':icon" size="mini" @click="buttonClick"
					v-if="alwaysShow || !readonly && !disabled" slot="append">
				</el-button>
			</el-input>
		</template>
		<template v-else>
			<el-link v-if="!value" type="info" style="font-size: 12px;color:rgb(233, 233, 235)" @click="buttonClick">
				{{'添加'+column.title}}
			</el-link>
			<div class="flex" style="flex-direction: row;align-items: center;width: 100%;" v-else>
				<quote v-if="quote" style="position: relative;display: inline-block;flex: 1;overflow: hidden;" type="primary" :row="row" :column="{field:'relationflowtitle'}" :value="value" :penetrate="true">
					{{value}}
				</quote>
				<div style="width: 100%;" v-else>{{value}}</div>
				<i class="el-icon-edit" style="margin: 0 5px;cursor: pointer;" @click="buttonClick"></i>
			</div>
		</template>
		<component ref="componentRef" :is="penetrateComponentConfig.component" v-bind="penetrateComponentConfig.props"
				v-if="penetrateComponentConfig" />
	</div>

</template>
<style scoped>
	.inputbutton {
		border-radius: 0px;
		box-sizing: border-box;
		border-left: 0px;
		position: relative;
		padding: 7px 0px;
	}
</style>
<script>
	import penetrate from '@_system/components/base/mixins/penetrate/penetrate.js'
	import selectBase from '@_system/components/base/select.js'
	import quote from '@_system/components/formcomponents/common/quote/index.vue'
	export default {
		mixins: [selectBase,penetrate],
		props: {
			icon: {
				type: String,
				default: () => {
					return 'el-icon-search'
				}
			},
			alwaysShow: {
				default: () => {
					return true
				}
			},
			quote: {
				default: () => {
					return true
				}
			}
		},
		data() {
			return {
				loading: false
			}
		},
		created() {


		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		methods: {
			customerpreview(e){
				if(e.target.nodeName=='INPUT'){
					if(this.penetrate && (this.readonly || this.disabled)){
						this.preview()
					}
				}
			},
			buttonClick() {
				if ((this.alwaysShow || !this.readonly && !this.disabled) && !this.loading) {
					this.$emit('inputButtonclick', {
						el: this
					})
				}

			},
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			}
		},
		components: {
			quote
		},
	}
</script>
